// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmtpManagement-space1-Dt_qp {
	margin-bottom: 6px !important;
}

.SmtpManagement-space2-X8z61 {
	margin-bottom: 12px !important;
}

.SmtpManagement-space3-BEByN {
	margin-bottom: 18px !important;
}

.SmtpManagement-space4-nJmv7 {
	margin-bottom: 24px !important;
}

.SmtpManagement-space5-HPhA5 {
	margin-bottom: 30px !important;
}

.SmtpManagement-space6-ZOCkr {
	margin-bottom: 36px !important;
}

.SmtpManagement-space7-a_h49 {
	margin-bottom: 42px !important;
}

.SmtpManagement-space8-ALgA8 {
	margin-bottom: 48px !important;
}

.SmtpManagement-spaceTop1-kdWK0 {
	margin-top: 6px !important;
}

.SmtpManagement-spaceTop2-ojCvt {
	margin-top: 12px !important;
}

.SmtpManagement-spaceTop3-B8B4y {
	margin-top: 18px !important;
}

.SmtpManagement-spaceTop4-AhSiH {
	margin-top: 24px !important;
}

.SmtpManagement-spaceTop5-j5Be6 {
	margin-top: 30px !important;
}

.SmtpManagement-spaceTop6-kyKju {
	margin-top: 36px !important;
}

.SmtpManagement-spaceTop7-xElLb {
	margin-top: 42px !important;
}

.SmtpManagement-spaceTop8-Krrxy {
	margin-top: 48px !important;
}

.SmtpManagement-noMargin-OYbj9 {
	margin: 0px !important;
}

.SmtpManagement-padding1-nDiQI {
	padding-bottom: 6px !important;
}

.SmtpManagement-padding2-BfKX4 {
	padding-bottom: 12px !important;
}

.SmtpManagement-padding3-HxKEc {
	padding-bottom: 18px !important;
}

.SmtpManagement-padding4-t7yXv {
	padding-bottom: 24px !important;
}

.SmtpManagement-padding5-yg0cZ {
	padding-bottom: 30px !important;
}

.SmtpManagement-padding6-iJQwQ {
	padding-bottom: 36px !important;
}

.SmtpManagement-padding7-iBNyC {
	padding-bottom: 42px !important;
}

.SmtpManagement-paddingTop1-ro7xk {
	padding-top: 6px !important;
}

.SmtpManagement-paddingTop2-AR0lf {
	padding-top: 12px !important;
}

.SmtpManagement-paddingTop3-EB1NY {
	padding-top: 18px !important;
}

.SmtpManagement-paddingTop4-V7EmH {
	padding-top: 24px !important;
}

.SmtpManagement-paddingTop5-KVsdB {
	padding-top: 30px !important;
}

.SmtpManagement-paddingTop6-iF_51 {
	padding-top: 36px !important;
}

.SmtpManagement-paddingTop7-eIYWx {
	padding-top: 42px !important;
}

.SmtpManagement-noPadding-s4ZXZ {
	padding: 0px !important;
}

.SmtpManagement-spaceMarginBottom0-qlLTb {
	margin-bottom: 0;
}

.SmtpManagement-textBold-ERHnY {
	font-weight: 500 !important;
}

.SmtpManagement-textBolder-x7XGR {
	font-weight: 700 !important;
}

.SmtpManagement-textNormal-advg0 {
	font-weight: normal !important;
}

/*New Design Text Colors */

.SmtpManagement-textDarkBlue-CWESF {
	color: rgb(20, 39, 94) !important;
}

.SmtpManagement-textLightBlue-SZPIY {
	color: rgb(57, 87, 106) !important;
}

.SmtpManagement-textLightSandleGreen-CfB6b {
	color: rgb(76, 86, 41) !important;
}

.SmtpManagement-textLightBrown-mnzeB {
	color: rgb(115, 79, 33) !important;
}

.SmtpManagement-textMediumMaroon-J23dF {
	color: rgb(87, 37, 51) !important;
}

.SmtpManagement-textBrown-c9Guc {
	color: rgb(160, 47, 24) !important;
}

.SmtpManagement-textMaroon-WV4Fv {
	color: rgb(155, 49, 67) !important;
}

.SmtpManagement-textDarkBrown-AxaBH {
	color: rgb(83, 18, 16) !important;
}

.SmtpManagement-textMediumBrown-FAECP {
	color: rgb(142, 28, 10) !important;
}

.SmtpManagement-textSkyBlue-ezJES {
	color: rgb(37, 117, 141) !important;
}

.SmtpManagement-textGray-Eo542 {
	color: rgb(77, 65, 51) !important;
}

.SmtpManagement-errorMessage-HL_Eu {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.SmtpManagement-userText-g7CVL {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.SmtpManagement-panelHeader-MBFBJ {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.SmtpManagement-exportSection-dMaG5 {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.SmtpManagement-exportSectionGridSub-TnIeR {
	grid-template-columns: 50% 49% !important;
}

.SmtpManagement-exportText-SV0vn {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.SmtpManagement-exportLinkImg-I9rse {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.SmtpManagement-exportImg-mq5i7 {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.SmtpManagement-linkBtn-FbyeG {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.SmtpManagement-table-AFNPG {
	display: table;
}

.SmtpManagement-tableRow-fvv51 {
	display: table-row;
}

.SmtpManagement-tableCell-ulBEm {
	display: table-cell;
	float: none;
}

.SmtpManagement-formGroup-u338D {
	margin-bottom: 6px;
}

.SmtpManagement-marginTop0-YJrfx {
	margin-top: 0;
}

.SmtpManagement-marginBottom20-gKGKL {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.SmtpManagement-bannerImageBg-ZDMLc {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.SmtpManagement-bannerDelete-bsHHf {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.SmtpManagement-exportLink-ScHxH {
	padding-top: 10px;
	padding-right: 10px;
}

.SmtpManagement-seachContent-y8TEW {
	padding-left: 0px;
	margin-bottom: 5px;
}

.SmtpManagement-marginBottom9-W9U9a {
	margin-bottom: 9px;
}

.SmtpManagement-spaceTop52-YFHf6 {
	margin-top: 52px;
}

.SmtpManagement-profileViewInner-ICsek {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.SmtpManagement-profileViewMain-fOUEe {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.SmtpManagement-profileViewlabel-cJURA {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.SmtpManagement-profileViewMainContent-xbTTl {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.SmtpManagement-reviewsFormStar-ibEb_ {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.SmtpManagement-reviewsFormStar-ibEb_ svg {
	cursor: pointer;
}

.SmtpManagement-addLanguageText-IUyOQ {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.SmtpManagement-exportSection-dMaG5 {
		grid-template-columns: 100%;
	}

	.SmtpManagement-spaceTop52-YFHf6 {
		margin-top: 18px;
	}

	.SmtpManagement-exportText-SV0vn {
		float: none;
		margin-top: 12px;
	}

	.SmtpManagement-exportSectionGridSub-TnIeR {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.SmtpManagement-profileViewlabel-cJURA {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.SmtpManagement-profileViewMainContent-xbTTl {
		width: 100%;
		text-align: center;
	}

	.SmtpManagement-panelHeader-MBFBJ {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `SmtpManagement-space1-Dt_qp`,
	"space2": `SmtpManagement-space2-X8z61`,
	"space3": `SmtpManagement-space3-BEByN`,
	"space4": `SmtpManagement-space4-nJmv7`,
	"space5": `SmtpManagement-space5-HPhA5`,
	"space6": `SmtpManagement-space6-ZOCkr`,
	"space7": `SmtpManagement-space7-a_h49`,
	"space8": `SmtpManagement-space8-ALgA8`,
	"spaceTop1": `SmtpManagement-spaceTop1-kdWK0`,
	"spaceTop2": `SmtpManagement-spaceTop2-ojCvt`,
	"spaceTop3": `SmtpManagement-spaceTop3-B8B4y`,
	"spaceTop4": `SmtpManagement-spaceTop4-AhSiH`,
	"spaceTop5": `SmtpManagement-spaceTop5-j5Be6`,
	"spaceTop6": `SmtpManagement-spaceTop6-kyKju`,
	"spaceTop7": `SmtpManagement-spaceTop7-xElLb`,
	"spaceTop8": `SmtpManagement-spaceTop8-Krrxy`,
	"noMargin": `SmtpManagement-noMargin-OYbj9`,
	"padding1": `SmtpManagement-padding1-nDiQI`,
	"padding2": `SmtpManagement-padding2-BfKX4`,
	"padding3": `SmtpManagement-padding3-HxKEc`,
	"padding4": `SmtpManagement-padding4-t7yXv`,
	"padding5": `SmtpManagement-padding5-yg0cZ`,
	"padding6": `SmtpManagement-padding6-iJQwQ`,
	"padding7": `SmtpManagement-padding7-iBNyC`,
	"paddingTop1": `SmtpManagement-paddingTop1-ro7xk`,
	"paddingTop2": `SmtpManagement-paddingTop2-AR0lf`,
	"paddingTop3": `SmtpManagement-paddingTop3-EB1NY`,
	"paddingTop4": `SmtpManagement-paddingTop4-V7EmH`,
	"paddingTop5": `SmtpManagement-paddingTop5-KVsdB`,
	"paddingTop6": `SmtpManagement-paddingTop6-iF_51`,
	"paddingTop7": `SmtpManagement-paddingTop7-eIYWx`,
	"noPadding": `SmtpManagement-noPadding-s4ZXZ`,
	"spaceMarginBottom0": `SmtpManagement-spaceMarginBottom0-qlLTb`,
	"textBold": `SmtpManagement-textBold-ERHnY`,
	"textBolder": `SmtpManagement-textBolder-x7XGR`,
	"textNormal": `SmtpManagement-textNormal-advg0`,
	"textDarkBlue": `SmtpManagement-textDarkBlue-CWESF`,
	"textLightBlue": `SmtpManagement-textLightBlue-SZPIY`,
	"textLightSandleGreen": `SmtpManagement-textLightSandleGreen-CfB6b`,
	"textLightBrown": `SmtpManagement-textLightBrown-mnzeB`,
	"textMediumMaroon": `SmtpManagement-textMediumMaroon-J23dF`,
	"textBrown": `SmtpManagement-textBrown-c9Guc`,
	"textMaroon": `SmtpManagement-textMaroon-WV4Fv`,
	"textDarkBrown": `SmtpManagement-textDarkBrown-AxaBH`,
	"textMediumBrown": `SmtpManagement-textMediumBrown-FAECP`,
	"textSkyBlue": `SmtpManagement-textSkyBlue-ezJES`,
	"textGray": `SmtpManagement-textGray-Eo542`,
	"errorMessage": `SmtpManagement-errorMessage-HL_Eu`,
	"userText": `SmtpManagement-userText-g7CVL`,
	"panelHeader": `SmtpManagement-panelHeader-MBFBJ`,
	"exportSection": `SmtpManagement-exportSection-dMaG5`,
	"exportSectionGridSub": `SmtpManagement-exportSectionGridSub-TnIeR`,
	"exportText": `SmtpManagement-exportText-SV0vn`,
	"exportLinkImg": `SmtpManagement-exportLinkImg-I9rse`,
	"exportImg": `SmtpManagement-exportImg-mq5i7`,
	"linkBtn": `SmtpManagement-linkBtn-FbyeG`,
	"table": `SmtpManagement-table-AFNPG`,
	"tableRow": `SmtpManagement-tableRow-fvv51`,
	"tableCell": `SmtpManagement-tableCell-ulBEm`,
	"formGroup": `SmtpManagement-formGroup-u338D`,
	"marginTop0": `SmtpManagement-marginTop0-YJrfx`,
	"marginBottom20": `SmtpManagement-marginBottom20-gKGKL`,
	"bannerImageBg": `SmtpManagement-bannerImageBg-ZDMLc`,
	"bannerDelete": `SmtpManagement-bannerDelete-bsHHf`,
	"exportLink": `SmtpManagement-exportLink-ScHxH`,
	"seachContent": `SmtpManagement-seachContent-y8TEW`,
	"marginBottom9": `SmtpManagement-marginBottom9-W9U9a`,
	"spaceTop52": `SmtpManagement-spaceTop52-YFHf6`,
	"profileViewInner": `SmtpManagement-profileViewInner-ICsek`,
	"profileViewMain": `SmtpManagement-profileViewMain-fOUEe`,
	"profileViewlabel": `SmtpManagement-profileViewlabel-cJURA`,
	"profileViewMainContent": `SmtpManagement-profileViewMainContent-xbTTl`,
	"reviewsFormStar": `SmtpManagement-reviewsFormStar-ibEb_`,
	"addLanguageText": `SmtpManagement-addLanguageText-IUyOQ`
};
module.exports = ___CSS_LOADER_EXPORT___;
